import { isEmpty, isNullish } from 'remeda'

/**
 * Normalises a raw text string.
 *
 * Trims leading/trailing whitespace and collapses multiple internal whitespace
 * characters into a single space. Returns `undefined` for any input that is
 * null, undefined, empty, or whitespace-only, so callers can rely on a simple
 * truthiness guard without an extra empty-string check.
 *
 * @param raw - The raw string to normalise, such as a free-text Shopify metafield value.
 */
export const normalizeText = (
  raw: string | null | undefined,
): string | undefined => {
  if (isNullish(raw)) {
    return undefined
  }

  const trimmed = raw.trim().replaceAll(/\s+/g, ' ')

  return isEmpty(trimmed) ? undefined : trimmed
}
